export const EDITS_IMGIX_HOSTNAMES = new Set(['airdev-edits.imgix.net', 'air-edits.imgix.net']);

export function isFromEditsBucket(url: string | undefined): boolean {
  if (!url) return false;
  try {
    return EDITS_IMGIX_HOSTNAMES.has(new URL(url).hostname);
  } catch {
    return false;
  }
}
